/**
 *  组件接口管理
 *  Bai.Zhiming
 *  2019-06-05
 */
angular.module("appThirdParyConfigModule", []).
controller("appThirdPartyConfigCtrl", ["$scope", "productMangageMentWebsiteService", "modalDialog", "$state", "trsHttpService", "productMangageMentAppService", function($scope, productMangageMentWebsiteService, modalDialog, $state, trsHttpService, productMangageMentAppService) {
    initStatus();
    initData();
    /**
     * [getRights description]获取权限
     * @return {[type]} [description] null
     */
    function getRights() {
        productMangageMentWebsiteService.getRight($state.params.site, "", "appsetsite.interface").then(function(data) {
            $scope.status.right = data.interface;
        });
    }
    /**
     * [selectAll description] 全选，取消全选
     * @return {[type]} [description]
     */
    $scope.selectAll = function() {
        if ($scope.data.selectedArray.length == $scope.data.items.length && $scope.data.selectedArray.length != 0) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = angular.copy($scope.data.items);
        }
    };
    /**
     * [selectItem description] 选中配置
     * @param  {[type]} item [description] 被选中数据信息
     * @return {[type]}      [description]
     */
    $scope.selectItem = function(item) {
        let flag = $scope.isChecked(item);
        if (flag.flag) {
            $scope.data.selectedArray.splice(flag.index, 1);
        } else {
            $scope.data.selectedArray.push(angular.copy(item));
        }
    };
    /**
     * [isChecked description] 配置是否被选中
     * @param  {[type]}  item [description] 被检验的数据信息
     * @return {Boolean}      [description] 
     */
    $scope.isChecked = function(item) {
        for (let i = 0; i < $scope.data.selectedArray.length; i++) {
            let item_ = $scope.data.selectedArray[i];
            if (item.APPSITEURLID == item_.APPSITEURLID) {
                return {
                    flag: true,
                    index: i
                }
            }
        }
        return {
            flag: false
        }
    };
    /**
     * [batDelete description] 批量删除
     * @return {[type]} [description]
     */
    $scope.batDelete = function() {
        modalDialog.alertType("确定要删除选中配置吗？", "", "ask", true, function() {
            deleteItem($scope.data.selectedArray.map((item, index) => {
                return item.APPSITEURLID;
            }).join(","));
        });
    };
    /**
     * [delete description] 单个删除
     * @param  {[type]} item [description] 被删除的数据信息
     * @return {[type]}      [description]
     */
    $scope.delete = function(item) {
        modalDialog.alertType("确定要删除该配置吗？", "", "ask", true, function() {
            deleteItem(item.APPSITEURLID);
        });
    };
    /**
     * [deleteItem description] 删除
     * @param  {[type]} ids [description]
     * @return {[type]}     [description]
     */
    function deleteItem(ids) {
        let params = {
            serviceid: "mlf_appsite",
            methodname: 'deleteAppSiteUrl',
            Ids: ids,
            SiteId: $state.params.site
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(resp => {
            modalDialog.alertType("删除成功", "", "success", false, function() {
                requestData();
            })
        });
    }
    /**
     * [create description] 新建
     * @return {[type]} [description]
     */
    $scope.create = function() {
        productMangageMentAppService.thirdPartyConfig().then(resp => {
            save(resp);
        }, resp => {});
    };
    /**
     * [edit description] 编辑
     * @param  {[type]} item [description] 被编辑项信息
     * @return {[type]}      [description]
     */
    $scope.edit = function(item) {
        productMangageMentAppService.thirdPartyConfig(angular.copy(item)).then(resp => {
            resp.id = resp.APPSITEURLID;
            save(resp);
        }, resp => {});
    };
    /**
     * [save description] 保存数据
     * @param  {[type]} item [description] 需要保存的信息
     * @return {[type]} [description]
     */
    function save(item) {
        item.serviceid = "mlf_appsite";
        item.methodname = "addAppSiteUrl";
        item.SiteId = $state.params.site;
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), item, 'post').then(resp => {
            modalDialog.alertType("保存成功", "", "success", false, function() {
                requestData();
            })
        });
    }
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {};
        $scope.data = {
            selectedArray: []
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        getRights();
        requestData();
    }
    /**
     * [requestData description] 
     * @return {[type]} [description]
     */
    function requestData() {
        let params = {
            serviceid: "mlf_appsite",
            methodname: "queryAppSiteUrlsBySiteId",
            SiteId: $state.params.site,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(resp => {
            $scope.data.items = resp;
            $scope.data.selectedArray = [];
        });
    }
}]);